module.exports = __webpack_public_path__ + "media/images/review_form_star-7f8070dc3b9d55040f5876af2f9324e9.svg";